/* global axios */
import ApiClient from './ApiClient';

class WhatsappLinksAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  index(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_links`);
  }

  create(inboxId, whatsappLink) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_links`, {
      whatsapp_link: whatsappLink,
    });
  }

  update(inboxId, id, whatsappLink) {
    return axios.patch(`${this.url}/${inboxId}/whatsapp_links/${id}`, {
      whatsapp_link: whatsappLink,
    });
  }
}

export default new WhatsappLinksAPI();
